export const web_extensions = {
    methods: {
        urlDecode: function(value) {
            if (value == null)
                return '';
            else
                return decodeURIComponent(value);
        },
        getParameterByName: function(name) {
            name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
                results = regex.exec(location.search);
            return results == null ? '' : this.urlDecode(results[1].replace(/\+/g, ' '));
        },
        redirect: function(location, paramsObject, newTab) {
            var url = '/';
            if (!this.isStringNullOrEmpty(location))
                url = url + location;

            if (!(paramsObject == null || paramsObject == undefined)) {
                url += '?';
                const entries = Object.entries(paramsObject)
                for (const [property, value] of entries) {
                    url += encodeURIComponent(property) + '=' + encodeURIComponent(value) + '&'
                }
                //remove last ','
                url = url.slice(0, -1);
            }
            //TODO: use $router.push instead of window.location
            //TODO: make sure origin is relative or atleast pointing to the same host
            if (newTab != null && (newTab == true || newTab == 'true'))
                window.open(window.location.origin + url);
            else
                window.location.href = window.location.origin + url;
        },
        getForm: function(form) {
            if (form == null)
                return null;

            var formElement = null;
            if (typeof form === 'string') {
                if (form.indexOf('form[') >= 0)
                    formElement = document.querySelector(form);
                else if (form.indexOf('form.') >= 0)
                    formElement = document.querySelector(form);
                else if (form.indexOf('#') == 0)
                    formElement = document.querySelector(form);
                else if (form.indexOf('.') == 0)
                    formElement = document.querySelector(form);
                else {
                    formElement = document.querySelector('form[name=' + form + ']');
                    if (formElement == null || formElement.length == 0)
                        formElement = document.querySelector('form.' + form);
                }
            } else {
                formElement = form;
            }

            return formElement;
        },
        getFormModel: function(form) {
            var formElement = this.getForm(form);
            if (formElement == null)
                return;

            var model = {};

            //Get the ID from the data attribute in the form
            if (formElement.getAttribute('id') != null)
                model.ID = formElement.getAttribute('id');

            //Get the GUID from the data attribute in the form
            if (formElement.getAttribute('guid') != null)
                model.GUID = formElement.getAttribute('guid');

            //Text
            formElement.querySelectorAll('input, select, textarea, div.multiselect-list-container').forEach(item => { model[item.getAttribute('name')] = item.value; });
            //Checkbox
            formElement.querySelectorAll('input[type=checkbox]').forEach(item => { model[item.getAttribute('name')] = item.checked; });
            //Radio
            formElement.querySelectorAll('input[type=radio]:checked').forEach(item => { model[item.getAttribute('name')] = item.value; });
            //State btn-group
            formElement.querySelectorAll('.state-container').forEach(item => { model[item.querySelector('input').getAttribute('name')] = item.querySelector('input').value; });

            return model;
        },
        showErrorDialog: function(title, error) {
            if (error == null)
                return;

            var message = null;
            if (typeof error === 'string') {
                message = error;
            } else if (!this.isStringNullOrEmpty(error.message)) {
                message = error.message;
            } else if (this.isStringNullOrEmpty(error.responseText))
                return;
            else {
                try {
                    var jsonResponse = JSON.parse(error.responseText);
                    message = jsonResponse.message;
                } catch (e) {
                    console.log(e); // error in the above string (in this case, yes)!
                    message = error.responseText;
                }
            }

            if (message == null || this.isStringNullOrEmpty(message))
                message = error.statusText;

            if (message == null || this.isStringNullOrEmpty(message))
                message = 'Unspecified error occurred.';
            
            this.$bvModal.msgBoxConfirm(message, {
                title: title,
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'OK',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
              });
        },
        getUrlParameter: function(name) {
            name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },
        showToaster(title = '', msg = '', type = 'secondary', position = 'b-toaster-top-center') {

            // TYPES:
            // default, primary, secondary, danger, warning, success, info

            // POSITIONS:
            // b-toaster-top-right || b-toaster-top-left || b-toaster-top-center || b-toaster-top-full ||
            // b-toaster-bottom-right || b-toaster-bottom-left || b-toaster-bottom-center || b-toaster-bottom-full

            var options = {
                title: title,
                toaster: position,
                variant: type,
                autoHideDelay: 5000,
                appendToast: true
            };
            options['body-class'] = '.mega';
            options['header-class'] = 'testing';
            this.$bvToast.toast(msg, options);
        }
    }
}